import Vue from 'vue' // eslint-disable-line
import axios from 'axios'

axios.defaults.timeout = 50000
axios.defaults.baseURL = 'https://wx.linksfield.net/vshop'

const Axios = axios.create({
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

Axios.interceptors.request.use(
  config => {
    return config
  },
  err => {
    return Promise.reject(err)
  })

Axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    return Promise.reject(error)
  })

// get 请求
export function get (url, params) {
  return new Promise((resolve, reject) => {
    Axios.get(url, {
      params: params
    }).then(res => {
      console.log(res.data)
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}

// post 请求
export function post (url, params) {
  return new Promise((resolve, reject) => {
    Axios.post(url, params)
      .then(res => {
        console.log(res.data)
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}



// WEBPACK FOOTER //
// ./src/axios/http.js